function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { buildClassNames } from '../../../modules/css-helpers';
import { createOwnUpComponent } from '../../components';
import { OwnUpHeaderStyle } from './style';
/**
 * Own Up header properties.
 */

/**
 * Determine the level of the header based on the variant.
 *
 * @param variant
 */
var determineLevel = function determineLevel(variant) {
  if (!variant) {
    return 2;
  }

  if (Array.isArray(variant)) {
    return variant.map(determineLevel).sort()[0];
  } else {
    switch (variant) {
      case 'title':
        return 1;

      case 'box':
        return 3;

      case 'greeting':
      case 'box':
        return 4;

      default:
        return 2;
    }
  }
};

var StyledH1 = createOwnUpComponent('h1', OwnUpHeaderStyle);
var StyledH2 = createOwnUpComponent('h2', OwnUpHeaderStyle);
var StyledH3 = createOwnUpComponent('h3', OwnUpHeaderStyle);
var StyledH4 = createOwnUpComponent('h4', OwnUpHeaderStyle);
var StyledH5 = createOwnUpComponent('h5', OwnUpHeaderStyle);
var StyledH6 = createOwnUpComponent('h6', OwnUpHeaderStyle);
/**
 * An Own Up branded header component.
 *
 * Variants:
 *  - `title`: Title - Slightly larger
 *  - `section`: Section - Sans-serif, bold, and smaller
 *  - `greeting`: Greeting - Sans-serif, spaced, uppercase, and smaller
 *  - `box`: Box - Sans-serif, uppercase, and smaller
 *
 * @param props See {@link OwnUpHeaderProps}
 */

export var OwnUpHeader = function OwnUpHeader(_ref) {
  var level = _ref.level,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["level", "className"]);

  var classes = buildClassNames('ou-header', className);
  level = level || determineLevel(props.variant);

  switch (level) {
    case 1:
      return /*#__PURE__*/React.createElement(StyledH1, _extends({
        className: classes
      }, props));

    case 2:
    default:
      return /*#__PURE__*/React.createElement(StyledH2, _extends({
        className: classes
      }, props));

    case 3:
      return /*#__PURE__*/React.createElement(StyledH3, _extends({
        className: classes
      }, props));

    case 4:
      return /*#__PURE__*/React.createElement(StyledH4, _extends({
        className: classes
      }, props));

    case 5:
      return /*#__PURE__*/React.createElement(StyledH5, _extends({
        className: classes
      }, props));

    case 6:
      return /*#__PURE__*/React.createElement(StyledH6, _extends({
        className: classes
      }, props));
  }
};